import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

interface LoadingScreenProps {
  message?: string;
  className?: string;
}

/**
 * Auth / route gate loader. Midnight Mode only — never flash light surfaces
 * during RequireAuth navigation (admin mobile PWA Phase A).
 */
export function LoadingScreen({ message = 'Loading…', className = '' }: LoadingScreenProps) {
  return (
    <div
      className={cn(
        'min-h-dvh min-h-[100dvh] bg-[#020617] flex items-center justify-center pb-safe pt-[env(safe-area-inset-top,0px)]',
        className
      )}
      data-testid="loading-screen"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="text-center animate-in fade-in duration-500 px-6">
        <div className="relative mb-6 mx-auto w-16 h-16">
          <Loader2
            className="w-full h-full text-championship-gold animate-spin"
            strokeWidth={2.5}
            aria-hidden
          />
          <div className="absolute inset-0 rounded-full border-2 border-championship-gold/20 animate-pulse" />
        </div>
        <p className="text-base font-broadcast uppercase tracking-wider text-sport-text/80 animate-pulse">
          {message}
        </p>
        <div className="mt-4 flex justify-center gap-1.5" aria-hidden>
          <div
            className="w-2 h-2 bg-championship-gold rounded-full animate-bounce"
            style={{ animationDelay: '0ms' }}
          />
          <div
            className="w-2 h-2 bg-championship-gold rounded-full animate-bounce"
            style={{ animationDelay: '150ms' }}
          />
          <div
            className="w-2 h-2 bg-championship-gold rounded-full animate-bounce"
            style={{ animationDelay: '300ms' }}
          />
        </div>
      </div>
    </div>
  );
}
